import React, { createContext, useState, useEffect } from "react";
import axios from 'axios';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({ token: null, user: null });


    const refreshUser = async () => {
        const token = localStorage.getItem('token');
        if (!token) return;

        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/user/me`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            const userData = res.data;

            const newAuth = {
                ...auth,
                user: userData
            };

            setAuth(newAuth);
            
            if (userData.name) {
                localStorage.setItem('userName', userData.name);
            }

            if (userData.point !== undefined) {
                localStorage.setItem('userPoints', userData.points);
            }

        } catch (error) {
            console.error('Blad odswiezania danych uzytkownika:', error.response?.data?.message);
            if (error.response?.status === 401) {
                logout();
            }
        }
    };

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            const userName = localStorage.getItem('userName');

            const userPoints = localStorage.getItem('userPoints')

            setAuth({
                token,
                user: {
                    name: userName,
                    points: userPoints ? Number(userPoints) : undefined
                }
            });


            axios.get(`${process.env.REACT_APP_API_URL}/api/user/me`, {
                headers: { 'Authorization': `Bearer ${token}` }
            }).then(res => {
                setAuth({ token, user: res.data });

                if (res.data.point !== undefined) {
                    localStorage.setItem('userPoints', res.data.points)
                }
            }).catch(err => {
                console.error("Sesja wygasla lub blad autoryzacji:", err);

                logout();
            })
        }
    }, []);

    const login = async (email, password) => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, { email, password });
            const { token } = res.data;

            const payloadObject = JSON.parse(atob(token.split('.')[1]));
            const userName = payloadObject.user.name;
            const userPoints = payloadObject.user.points;


            localStorage.setItem('token', token);
            localStorage.setItem('userName', userName);
            localStorage.setItem('userPoints', userPoints);
            setAuth({ token, user: { name: userName, points: userPoints } });

            const userRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/me`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setAuth({
                token, user: userRes.data
            })

            return true;

        } catch (error) {
            console.error('Blad logowania', error.response?.data?.message);
            return false;
        }
    };

    const register = async (name, email, password) => {
        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/register`, { name, email, password });
            return await login(email, password);
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Wystapil blad podczas rejestracji';
            console.error('Blad rejestracji:', errorMessage);
            return { success: false, message: errorMessage };
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userName');
        setAuth({ token: null, user: null });
    };

    return (
        <AuthContext.Provider value={{ auth, login, register, logout, refreshUser }}>
            {children}
        </AuthContext.Provider>
    )
};

export default AuthContext;